import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import { authApi } from "../toolkit/auth/authApi";
import { signinApi } from "../toolkit/signin/signinApi";
import { carEstimateApi } from "../toolkit/carEstimate/carEstimateApi";
import { savedData } from "../utils/constants/localStorage";
import { setAuthAction } from "../toolkit/auth/authSlice";
import { reducerPaths } from "./reducerPaths";
import { myGarageApi } from "../toolkit/myGarage/myGarageApi";
import { carDetailsApi } from "../toolkit/carDetails/carDetailsApi";
import { upcomingCarsApi } from "../toolkit/upcomingCars/upcomingCarsApi";
import { liveAuctionApi } from "../toolkit/liveAuction/liveAuctionApi";
import { carsInNegotiationApi } from "../toolkit/carsInNegotiation/carsInNegotiationApi";
import { dashboardReportApi } from "../toolkit/dashboardReport/dashboardReportApi";
import { contactUsApi } from "../toolkit/contactUs/contactUsApi";
import { vehicleApi } from "../toolkit/vehicle/vehicleApi";
import { geographyApi } from "../toolkit/geography/geographyApi";
import { paypalApi } from "../toolkit/paypal/paypalApi";
import { carfaxApi } from "../toolkit/carfax/carfaxApi";
import { buyNowApi } from "../toolkit/buyNow/buyNowApi";
import { watchListApi } from "src/toolkit/watchList/watchListApi";
import { myOrdersApi } from "src/toolkit/myOrders/myOrdersApi";
import { walletAndPaymentsApi } from "@common/toolkit/walletAndPayments/walletAndPaymentsApi";
import { dashboardPaginationFiltersApi } from "src/toolkit/dashboardPaginationFilters/dashboardPaginationFiltersApi";
import { signupApi } from "src/toolkit/auth/signupApi";
import { paymentsApi } from "src/toolkit/payments/paymentsApi";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
    .concat(authApi.middleware)
    .concat(signinApi.middleware)
    .concat(signupApi.middleware)
    .concat(carEstimateApi.middleware)
    .concat(myGarageApi.middleware)
    .concat(carDetailsApi.middleware)
    .concat(upcomingCarsApi.middleware)
    .concat(buyNowApi.middleware)
    .concat(liveAuctionApi.middleware)
    .concat(carsInNegotiationApi.middleware)
    .concat(vehicleApi.middleware)
    .concat(dashboardReportApi.middleware)
    .concat(contactUsApi.middleware)
    .concat(geographyApi.middleware)
    .concat(paypalApi.middleware)
    .concat(carfaxApi.middleware)
    .concat(watchListApi.middleware)
    .concat(myOrdersApi.middleware)
    .concat(walletAndPaymentsApi.middleware)
    .concat(dashboardPaginationFiltersApi.middleware)
    .concat(paymentsApi.middleware)
});

// --------------------------------------------------------------------------------------------------------
const populateReduxStoreFromLocalStorageHandler = () => {
  const parsedLocalStorage = JSON.parse(localStorage.getItem(savedData.state));

  if (parsedLocalStorage) {
    store.dispatch(setAuthAction(parsedLocalStorage[reducerPaths.auth]));
  }
};

populateReduxStoreFromLocalStorageHandler();
// --------------------------------------------------------------------------------------------------------

// let previousSellMyCarDashboardState = store.getState().sellMyCarDashboard;
let previousAuthState = store.getState().auth;

const unsubscribe = store.subscribe(() => {
  // const currentSellMyCarDashboardState = store.getState().sellMyCarDashboard;
  // if (currentSellMyCarDashboardState !== previousSellMyCarDashboardState) {
  //   let localStorageState = JSON.parse(localStorage.getItem(savedData.state));
  //   localStorageState = {
  //     ...localStorageState,
  //     sellMyCarDashboard: currentSellMyCarDashboardState
  //   };

  //   localStorage.setItem(savedData.state, JSON.stringify(localStorageState));
  //   // Perform your action here when sellerSidebar changes
  //   // For example, you might want to log something, trigger another action, etc.
  //   previousSellMyCarDashboardState = currentSellMyCarDashboardState; // Update the previous state
  // }

  const currentAuthState = store.getState().auth;
  if (currentAuthState !== previousAuthState) {
    let localStorageState = JSON.parse(localStorage.getItem(savedData.state));
    localStorageState = {
      ...localStorageState,
      auth: currentAuthState,
    };

    localStorage.setItem(savedData.state, JSON.stringify(localStorageState));
    // Perform your action here when sellerSidebar changes
    // For example, you might want to log something, trigger another action, etc.
    previousAuthState = currentAuthState; // Update the previous state
  }
});

export default store;
